module.exports = __webpack_public_path__ + "static/media/image_6.98717f0d.png";